import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Glyphicon} from 'react-bootstrap';

class EditableField extends Component {

  constructor(props) {
    super(props);

    this.state = {
      editing: !!props.editing
    };
  }

  toggleMode = () => {
    if (typeof this.props.editing === 'boolean') {
      this.props.onToggle(!this.props.editing);
    } else {
      this.setState(prevState => ({ editing: !prevState.editing }));
    }
  };

  render() {
    const editing = typeof this.props.editing === 'boolean' ? this.props.editing : this.state.editing;

    if (!editing) {
      return (
        <div className='flex-row'>
          { this.props.value }<a data-cy='edit-button' onClick={this.toggleMode}><Glyphicon style={{ fontSize: '15px', marginLeft: '10px', marginRight: '10px' }} glyph='pencil'/></a>
        </div>
      );
    } else {
      return (
        <div className='flex-row'>
          {React.Children.only(this.props.children)} <a data-cy='submit-edit-button' onClick={this.toggleMode}><Glyphicon style={{ fontSize: '15px', marginLeft: '10px', marginRight: '10px' }} glyph='ok'/></a>
        </div>
      );
    }
  }
}

EditableField.propTypes = {
  value: PropTypes.any.isRequired,
  editing: PropTypes.bool,
  onToggle: PropTypes.func,
};

export default EditableField;



// WEBPACK FOOTER //
// ./src/components/engagement/EditableField.js